import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { get } from "lodash";

import { CalendarView } from "@ds-developer/calendar";

import { CalendarState } from "./types";

export const initialCalendarState: CalendarState = {
  initialDate: undefined,
  view: CalendarView.day,
  selectedEventId: null,
  eventsLoading: false,
  showAddLessonModal: false,
};

export const {
  actions: calendarActions,
  reducer: calendarReducer,
} = createSlice({
  name: "calendar",
  initialState: initialCalendarState,
  reducers: {
    calendarInitialDateChanged: (
      state,
      action: PayloadAction<{ initialDate?: Date }>,
    ) => {
      state.initialDate = action.payload.initialDate;
    },
    calendarViewSelected: (
      state,
      action: PayloadAction<{ view: CalendarView }>,
    ) => {
      state.view = action.payload.view;
    },
    desktopViewRendered: state => {
      state.view = CalendarView.week;
    },
    calenderEventClicked: (state, action: PayloadAction<{ id: string }>) => {
      state.selectedEventId = get(action, "payload.id");
    },
    calendarEventClosed: state => {
      state.selectedEventId = null;
    },
    calendarEventsLoading: (
      state,
      action: PayloadAction<{ loading: boolean }>,
    ) => {
      state.eventsLoading = action.payload.loading;
    },
    calendarShowAddLessonModal: (
      state,
      action: PayloadAction<{ showAddLessonModal: boolean }>,
    ) => {
      state.showAddLessonModal = action.payload.showAddLessonModal;
    },
  },
});
